import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowRightIcon } from './Icons';
export function PricingSection() {
  const headingReveal = useScrollReveal();
  const cardReveal = useScrollReveal();
  return <section className="py-20 bg-charcoal text-white relative overflow-hidden" data-id="element-149">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#C4A265 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-150" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-151">
        <div ref={headingReveal.ref} className={`text-center mb-12 reveal ${headingReveal.isVisible ? 'visible' : ''}`} data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold mb-6" data-id="element-153">
            No vas a pagar los $552 que vale este sistema.
          </h2>
          <p className="text-lg md:text-xl font-sans text-gray-300 max-w-2xl mx-auto" data-id="element-154">
            Ni siquiera los $197 que cuesta el libro principal por separado.
            Como parte de nuestro lanzamiento para ayudar a 10,000 mujeres a
            recuperar su salud este año...
          </p>
        </div>

        <div ref={cardReveal.ref} className={`bg-white text-charcoal rounded-3xl p-8 md:p-12 shadow-2xl relative max-w-2xl mx-auto reveal-scale delay-200 ${cardReveal.isVisible ? 'visible' : ''}`} data-id="element-155">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold text-white px-6 py-2 rounded-full font-sans font-bold text-sm tracking-wider shadow-lg whitespace-nowrap" data-id="element-156">
            OFERTA DE LANZAMIENTO
          </div>

          <div className="text-center mb-8" data-id="element-157">
            <p className="font-sans text-charcoal-light mb-2 uppercase tracking-wide text-sm font-semibold" data-id="element-158">
              Llévatelo TODO hoy por solo:
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-159">
              <span className="text-3xl font-sans text-charcoal-light line-through decoration-red-500/50 decoration-2" data-id="element-160">
                $552
              </span>
              <span className="text-6xl md:text-7xl font-playfair font-bold text-sage-dark" data-id="element-161">
                $7{' '}
                <span className="text-2xl font-sans font-normal text-charcoal-light" data-id="element-162">
                  USD
                </span>
              </span>
            </div>
          </div>

          <a href="https://www.doctormomstudio.com/cart/52358733168821:1" className="w-full py-5 bg-gold hover:bg-gold-dark text-white rounded-xl font-sans font-bold text-xl transition-all duration-300 shadow-[0_8px_30px_rgb(196,162,101,0.3)] hover:shadow-[0_8px_30px_rgb(196,162,101,0.5)] hover:-translate-y-1 flex items-center justify-center gap-3 group mb-6" data-id="element-163">
            ACCESO INMEDIATO POR $7
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-164" />
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm font-sans text-charcoal-light" data-id="element-165">
            <div className="flex items-center gap-2" data-id="element-166">
              <svg className="w-5 h-5 text-sage" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-167">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-168" />
              </svg>
              Pago 100% Seguro
            </div>
            <div className="hidden sm:block w-1 h-1 bg-cream rounded-full" data-id="element-169" />
            <div className="flex items-center gap-2" data-id="element-170">
              <svg className="w-5 h-5 text-sage" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-171">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" data-id="element-172" />
              </svg>
              Acceso de por vida
            </div>
          </div>
        </div>
      </div>
    </section>;
}